<template>
    <div key="attachment">
        <b-modal v-model="isVisible" hide-footer class="pt-8" header-class="p-0" content-class="custom-model-wrap">
            <template #modal-title="{ cancel }">
                <div class="title-block text-center p-2">{{ $translate('uploaded_file') }}</div>
                <div class="close-btn" @click.prevent="cancel()">×</div>
            </template>
            <b-img :src="model.url" v-if="['jpg', 'jpeg', 'png'].includes(
                model && model.file_extension
            )" fluid alt="Responsive image"></b-img>
            <a id="xls-show-btn" v-else-if="['xls', 'xlsx'].includes(
                model && model.file_extension
            )
                " :href="model && model.url" @click="downloadFile($event, model)">
                <div class="btn btn-success btn-sm">
                    <i v-b-tooltip.hover :title="$translate('click_to_download')" class="fa-solid fa-file-excel fa-2x"></i>
                </div>
            </a>
            <a id="pdf-show-btn" v-else-if="model && model.file_extension == 'pdf'" :href="model && model.url" @click="downloadFile($event, model)">
                <div class="btn delete-button btn-sm">
                    <i v-b-tooltip.hover :title="$translate('click_to_download')" class="fa fa-file-pdf fa-2x"></i>
                </div>
            </a>

            <video v-else-if="['mp4'].includes(
                model && model.file_extension
            )
                " width="50%" height="50%" controls>
                <source :src="model.url" type="video/mp4">
            </video>

            <a id="file-show-btn" v-else :href="model && model.url">
                <div class="btn btn-success btn-sm">
                    <i class="fa fa-file fa-2x"></i>
                </div>
            </a>
            <br />
            <div class="row px-3">
                <b-list-group class="mt-2 col-12 col-sm-9">
                    <b-list-group-item class="d-inline-flex p-2">
                        <!--file name input to rename the file before upload-->
                        <b-form-input :disabled="viewMode && !isNew" id="file_name" :placeholder="$translate('file_name_placeholder')"
                            v-model="model.name" required />
                        <!--file extension-->
                        <span class="d-inline-flex align-items-center text-muted ml-1 mr-3">.{{ model.file_extension
                        }}</span>
                        <b-form-textarea placeholder="Description"  v-model="model.description"
                        ref="inputField"  ></b-form-textarea>
                    </b-list-group-item>
                </b-list-group>
                <b-col cols="12" sm="3" class="align-self-center pt-2">
                    <b-button id="rename-file-btn" type="submit" variant="info" :disabled="viewMode && !isNew" class="btn-fw"
                        @click.prevent="renameFileName(model.index, model.name)">
                        {{ $translate('rename') }}
                    </b-button>
                </b-col>
            </div>
            <div class="text-center mt-3">
                <b-button id="delete-file-btn" variant="delete-button" class="btn-fw ms-2" :disabled="viewMode && !isNew"
                    v-if="hasPermissionDelete" @click.prevent="deleteAttachment(model.hash)">{{ $deleteLabel() }}</b-button>

            </div>
        </b-modal>
        <b-modal v-model="showModal" id="add-attachments-modal" centered header-class="p-0"
            footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap" hide-footer>
            <template #modal-title="{ cancel }">
                <div class="text-center">
                    <div class="title-block text-center p-2">{{ $translate('files_upload') }}</div>
                    <div class="close-btn" @click.prevent="cancel()">×</div>
                </div>
            </template>
            <b-overlay :show="submitting" rounded="sm">
                <b-row>
                   
                    <b-col sm="12" xl="12" v-if="this.filelist.length" v-cloak>
                        <!--show a list of the selected files, with an input to (optionally) rename the file before upload-->
                        <b-list-group>
                            <b-list-group-item class="d-flex align-items-center p-2" v-for="(file, i) in filelist" :key="i">
                                <!--file name input to rename the file before upload-->
                                <b-form-group :label="$translate('file_name_placeholder')" label-for="rename-file-name-input" class="mb-0 flex-grow-1">
                                <b-form-input id="rename-file-name-input" :placeholder="$translate('file_name_placeholder')" v-model="filelist[i].fileName"
                                    required @change="renameFile(i, filelist[i].fileName)" ref="inputField" @click.prevent="selectText(i)"
                                    class="flex-grow-1 mr-2" />
                                </b-form-group>
                                <!--file extension-->
                                <span class="text-muted mx-2">.{{ filelist[i].extension }}</span>
                                <b-form-group :label="$translate('description')" label-for="rename-file-input-small" class="mb-0 flex-grow-1">
                                <!--description input-->
                                <b-form-textarea id="rename-file-input-small" :placeholder="$translate('description')" v-model="filelist[i].description"
                                    class="flex-grow-1 mr-2" ></b-form-textarea>
                                </b-form-group>
                                &nbsp;&nbsp;
                                <!--remove file from list (and from upload)-->
                                <b-button id="delete-file-btn" variant="outline-danger" size="sm" @click.prevent="remove(filelist.indexOf(file))">
                                    <b-icon-trash></b-icon-trash>
                                </b-button>
                            </b-list-group-item>
                        </b-list-group>
                        
                    </b-col>

                    <!--this column contains the file drop area-->
                    <!--its width is automatically set based on existance of the file list column and breakpoint-->
                    <b-col class="file-drop-column my-4 my-xl-0 p-0">
                        <div class="file-drop-area bg-light" @dragover="dragover" @drop="drop">
                            <!--we need an actual file input in order to have the drag&drop functionality-->
                            <!--and the File object(s) containing the files dropped-->
                            <!--We keep it invisible because we want to display something different than a file input-->
                            <input type="file" name="file-input" id="file-input" class="file-input invisible"
                                @change="onChange" />

                            <!--clicking on this label will trigger the clicked event on the file input-->
                            <!--this will cause the 'choose file' system dialog-->
                            <label for="file-input" class="w-100 text-center attachment-cursor cursor-pointer text-muted m-0 px-3 py-5">
                                <p>
                                    <b-icon-cloud-upload-fill font-scale="3"></b-icon-cloud-upload-fill>
                                </p>
                                <div>
                                    <p class="mb-0">{{ $translate('upload_file_note') }}</p>
                                    <p class="mb-0">
                                        <span class="text-info">{{ $translate('select_from_computer') }}</span>
                                    </p>
                                </div>
                            </label>
                        </div>
                    </b-col>
                </b-row>

                <div class="text-center mt-4">
                    <b-button id="cancel-file-bnt" variant="info" @click.prevent="$bvModal.hide('add-attachments-modal')" class="me-3 btn-fw">
                        {{ $cancelLabel() }}
                    </b-button>
                    <b-button id="upload-file-btn" type="submit" :disabled="!filelist.length" variant="info" class="btn-fw" @click.prevent="onSubmit()">
                        {{ $translate('upload_files') }}
                    </b-button>
                </div>
            </b-overlay>
        </b-modal>
        <b-row class="align-items-center">
            <b-col cols="9" md="11">
                <b-container fluid class="form-control ">
                    <b-row class="attachment">
                        <b-col v-for="(item, index) in attachments" :key="index" md="2" class="mt-2 mt-md-0">
                            <button :id="'image-file-btn'+index" class="test-image-file-btn" v-if="['jpg', 'jpeg', 'png'].includes(
                                item.file_extension
                            )" @click.prevent="setModel(item, index)">
                                <b-img :height="imageHeight" :width="imageWidth" :src="item.url" alt="Image 1"></b-img>
                            </button>
                            <button  :id="'excel-file-btn'+index" class="test-excel-file-btn" v-else-if="['xls', 'xlsx'].includes(
                                item.file_extension
                            )
                                " @click.prevent="setModel(item, index)">
                                <div class="btn btn-success btn-sm">
                                    <i class="fa-solid fa-file-excel fa-2x"></i>
                                </div>
                            </button>
                            <button :id="'audio-file-btn'+index" class="test-audio-file-btn" v-else-if="['mp4'].includes(
                                item.file_extension
                            )
                                " @click.prevent="setModel(item, index)">
                                <div class="btn btn-dark btn-sm">
                                    <i class="fa-solid fa-play"></i>
                                </div>
                            </button>
                            <button :id="'pdf-file-btn'+index" class="test-pdf-file-btn" v-else-if="item.file_extension == 'pdf'" @click.prevent="setModel(item, index)">
                                <div class="btn delete-button btn-sm">
                                    <i class="fa-solid fa-file-pdf fa-2x"></i>
                                </div>
                            </button>
                            <button :id="'file-btn'+index" class="test-file-btn" v-else @click.prevent="setModel(item, index)">
                                <div class="btn btn-success btn-sm">
                                    <i class="fa fa-file fa-2x"></i>
                                </div>
                            </button>
                            <div>
                                <label>{{ item.name ? item.name + '.' + item.file_extension : '' }}</label><br>
                                <div class="mt-1 mb-2" v-if="item.updated_at">
                                    <label><b>{{ $translate('upload_on') }}</b></label>
                                    <label>{{ item.created_at | displayTime }}</label>
                                </div>
                            </div>
                        </b-col>
                        <b-col v-if="!attachments.length">
                            <h4 class="text-black">{{ $translate('no_attachments_submitted') }}</h4>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
            <b-col cols="3" md="1">
                <b-button id="upload-cloud-btn" variant="info" :disabled="(viewMode && !isNew)" @click.prevent="showModal = !showModal">
                    <b-icon icon="cloud-upload"></b-icon>
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import locationMixins from '@/mixins/locationMixins'

export default {
    name: 'orders-attachments',

    mixins: [popupMixins, permissionsMixins, locationMixins],

    props: {
        viewMode: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
    },

    data() {
        return {
            imageHeight: 60,
            imageWidth: 60,
            submitting: false,
            extension: '',
            model: {
                "name": null,
                "description" :null
            },
            isVisible: false,
            // attachmentName: '',
            filelist: [],
            // attachment: null,
            // Controls Filepicker modal
            showModal: false,
        }
    },
    computed: {
        componentName() { return this.$translate('master_document_attachment') },

       
        assetAttachments() {
            return this.$store.state.master_document.attachments
        },
        attachments() {
            return this.$store.state.masterdocAttachmentsStore.attachments
        },
        mediaBaseUrl() {
            return this.$store.getters['mediaBaseUrl']
        },
    },
    filters: {
        displayTime(date) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
            console.log('timezone', timezone)
            if (date) {
                return new Date(date).toLocaleString('en-US', {
                    timeZone: timezone,
                })
            } else {
                return ''
            }
        },

    },
    watch: {
        'assetAttachments': {
            handler: function (items) {
                this.storeAttachments(items)
            },
            deep: true,
        },
    },
    mounted() {
        setTimeout(() => {
            this.$store.dispatch('js_report/fetchCredentials')
        }, 500)
        // const { attachments } = this.order
        // this.storeAttachments(attachments)

        const attachments = this.assetAttachments
        console.log('attachments are ---',attachments);
        this.storeAttachments(attachments)
        document.addEventListener('paste', this.handlePaste);
    },
    methods: {
        onSubmit() {
            event.preventDefault()
            this.submitting = true;
            console.log(
                'Perfect! Now implement some way to upload these files: '
            )
            console.log(this.filelist)
            this.createAttachment()
                .then(() => {
                    this.submitting = false;
                })
                .catch((error) => {
                    console.log(error)
                    this.submitting = false;
                })
        },

        storeAttachments(attachments) {            
            this.$store.dispatch(
                'masterdocAttachmentsStore/load',
                attachments || []
            )
        },
        renameFile(fileIndex, newName) {
            const file = this.filelist[fileIndex].file
            var newFile = new File(
                [file],
                `${newName}.${this.filelist[fileIndex].extension}`,
                {
                    type: file.type,
                }
            )

            // Rebuild File Obj for file list array
            const fileName = newFile.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
            const extension = newFile.name.split('.').pop() //extract

            this.filelist[fileIndex] = {
                fileName: fileName,
                extension: extension,
                file: newFile,
            }
        },
        renameFileName(fileIndex, newName) {
            const file = this.attachments[fileIndex]
            if (!newName) {
                this.doToast(this.$translate('error'), this.$translate('file_name_required'), 'danger')
                return false
            }
            file.name = newName
            if (file.id) {
                this.$store.dispatch('masterdocAttachmentsStore/renameAttachment', {
                    file,
                })
                this.isVisible = false
            } else {
                this.attachments[fileIndex] = file
                this.updateAttachment(this.attachments)
                this.isVisible = false
            }
        },
        onChange(event) {
            let allowedTypes = this.$allowedTypes
            let uploadedFileName = event.target.files[0].name;
            let fileExtension = uploadedFileName.split('.').pop();
            let maxFileSize = this.$maxFileSize
            console.log("event.target.files", event.target.files)
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger')
                return false;
            }
            if (fileExtension === 'mp4' || fileExtension === 'avi' || fileExtension === 'mov' || fileExtension === 'mkv') {
                // Video file detected, enforce max size limit for videos
                if ((10 * 1024 * 1024) < event.target.files[0].size) {
                    this.doToast(this.$translate('error'), this.$translate('video_file_size_alert'), 'danger');
                    return false;
                }
            } else {
                // Other file types, enforce general max size limit
                if (maxFileSize < event.target.files[0].size) {
                    this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger');
                    return false;
                }
            }
                    const fileArray = [...event.target.files] //put the files in a temporary array
            fileArray.forEach(file => {
                const fileName = file.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
                const extension = file.name.split('.').pop() //extract extensionfrom the file fullname
                this.filelist.push({
                    fileName: fileName,
                    extension: extension,
                    file: file,
                    description : null,
                }) //store selected files and additional data in our array
            })
        },
        onChangeDrop(event) {
            console.log('event_data---',event.dataTransfer.files[0]);
            let allowedTypes = this.$allowedTypes
            let uploadedFileName = event.dataTransfer.files[0].name;
            let fileExtension = uploadedFileName.split('.').pop();
            let maxFileSize = this.$maxFileSize
          
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger')
                return false;
            }
            if (maxFileSize < event.dataTransfer.files[0].size) {
                this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger')
                return false
            }
            const fileArray = [...event.dataTransfer.files] //put the files in a temporary array
            fileArray.forEach(file => {
                const fileName = file.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
                const extension = file.name.split('.').pop() //extract extensionfrom the file fullname
                this.filelist.push({
                    fileName: fileName,
                    extension: extension,
                    file: file,
                    description : null,
                }) //store selected files and additional data in our array
            })
        },
        onPaste(event) {
            console.log('on pastes is called');
            const clipboardData = event.clipboardData || window.clipboardData;
            if (clipboardData) {
            const items = clipboardData.items;
            const fileList = [];
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.kind === 'file') {
                const file = item.getAsFile();
                fileList.push(file);
                }
            }
            this.handleFiles(fileList);
            }
        },
        handlePaste(event) {
           
            const modalElement = document.getElementById('add-attachments-modal');
           
            
            if (modalElement) {
                this.onPaste(event);
            } else {
                console.log('Else is called');
            }
        },

        handleFiles(fileList) {
            // Common functionality
            let allowedTypes = this.$allowedTypes;
            let maxFileSize = this.$maxFileSize;
            
            fileList.forEach(file => {
            const uploadedFileName = file.name;
            const fileExtension = uploadedFileName.split('.').pop();
            
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger');
                return false;
            }
            
            if (maxFileSize < file.size) {
                this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger');
                return false;
            }
            
            const fileName = uploadedFileName.replace(/\.[^/.]+$/, '');
            const extension = uploadedFileName.split('.').pop();
            this.filelist.push({
                fileName: fileName,
                extension: extension,
                file: file,
                description : null,
            });
            });

       },
   
        remove(i) {
            this.filelist.splice(i, 1)
        },
        removeAll(i) {
            this.filelist.splice(i, i.length)
        },
        setModel(item, i) {
            this.model = { ...item, index: i }
            this.isVisible = true
        },

        dragover(event) {
            event.preventDefault()
        },
        drop(event) {
            event.preventDefault()
            this.onChangeDrop(event)
        },
        async updateAttachment(newFiles) {
            this.$store.dispatch('masterdocAttachmentsStore/merge', {
                newFiles,
            })
        },
        async createAttachment() {
            console.log('upload event', this.filelist)
            try {
                this.submitting = true
                const files = this.filelist.map(file => ({
                        file: file.file,
                        description: file.description // Include description
                    }));
                    console.log('this is update-----',files);
                const p = await this.getCurrentLocation()
                console.log('coordinates', p)
                const lat = p.coords.latitude
                const long = p.coords.longitude
                // const file_extension =  files[0].name.split('.').pop()
                let { keys } = await this.$store.dispatch(
                    's3files/s3uploadOrder',
                    files
                )
                let url = []
                keys.forEach(key => {
                    url.push(`${this.mediaBaseUrl}/${key}`)
                })
                // const newFiles = []
                // files.forEach((element, i) => {
                //     newFiles.push({
                //         name: element.name.replace(/\.[^/.]+$/, ''),
                //         url: url[i],
                //         file_extension: element.name.split('.').pop(),
                //         lat: lat,
                //         long: long,
                //         description : element.fileDescription
                //     })
                // })
                const newFiles = files.map((element, i) => ({
                            name: element.file.name.replace(/\.[^/.]+$/, ''),
                            url: url[i],
                            file_extension: element.file.name.split('.').pop(),
                            lat: lat,
                            long: long,
                            description: element.description // Use description
                        }));
                        console.log('new files----',newFiles);
                this.$store.dispatch('masterdocAttachmentsStore/merge', {
                    newFiles,
                })

                // Hide modal after success
                this.showModal = false

                this.genericToast(
                    this.componentName,
                    this.$translate('uploaded'),
                    'success',
                    this.$translate(`attachment_uploaded_alert`)
                )
                this.removeAll(this.filelist)
            } catch (error) {
                console.error('addAttachement', error)

                this.doToast(this.$translate('error'), this.$translate('error_storing_attachment'), 'danger')
            } finally {
                this.submitting = false
            }
        },
        deleteAttachment(hash) {

            console.log(hash);
            this.$store.dispatch('masterdocAttachmentsStore/delete', hash)
            this.isVisible = false
        },
        selectText(i) {
        // Use $refs to access the input element and call select() on it
        this.$refs.inputField[i].select();
    },
    downloadFile(event, attachment) {
        event.preventDefault();
        fetch(attachment.url)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = attachment.name;  // This sets the name of the downloaded file
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(error => console.error('Download error:', error));
    }
    },
}
</script>

<style scoped>
    .attachment-cursor{cursor: pointer;}
</style>
